// Referral status → CSS-module class key. The returned key matches a class in
// PatientReferralsPage.module.css (used as `styles[getReferralStatusKey(...)]`).
export const getReferralStatusKey = (status) => {
  if (["INTEGRATED_BROWSER", "DRAFT", "EXTERNAL"].includes(status)) {
    return "external";
  }
  if (status === "SENT") return "completed";
  if (status === "ACCEPTED") return "accepted";
  if (status === "REJECTED") return "rejected";

  return "undelivered";
};

// Human-readable referral status. INTEGRATED_BROWSER is surfaced as "Draft".
export const getDisplayStatus = (status) => {
  const displayStatus = status === "INTEGRATED_BROWSER" ? "DRAFT" : status;

  if (!displayStatus) return "-";

  return (
    displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1).toLowerCase()
  );
};
